<template>
  <div class="UsersTableHeader">
    <el-table
      :data="clients"
      border
      :height="tableHeight"
      class="UserTable"
      header-row-class-name="UserTable-HeaderRow"
      header-cell-class-name="UserTable-HeaderCell"
      cell-class-name="UserTable-Cell"
    >
      <el-table-column label="ユーザー名" prop="name"></el-table-column>
      <el-table-column label="権限" align="center">
        <template slot-scope="scope">
          <font-awesome-icon
            class="userActive"
            v-if="scope.row.role === 'CLIENT_USER'"
            :icon="['fal', 'check']"
            size="1x"
          >
          </font-awesome-icon>
          <span class="user-text" v-if="scope.row.role === 'CLIENT_USER'"
            >通常</span
          >
          <span class="user-space" v-else>通常</span>
          <font-awesome-icon
            class="userActive"
            v-if="scope.row.role === 'CLIENT_CONTRIBUTOR'"
            :icon="['fal', 'check']"
            size="1x"
          >
          </font-awesome-icon>
          <span
            class="user-space"
            v-if="scope.row.role === 'CLIENT_CONTRIBUTOR'"
            >制限あり</span
          >
          <span class="user-text" v-else>制限あり</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button @click="_onClickEditUser(scope.row.id)">編集</el-button>
          <el-button type="danger" @click="getDeleteUserDialog(scope.row.id)"
            >削除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- Dialogs Division -->
    <div class="UserDeleteDialog">
      <!-- edit user dialog -->
      <el-dialog :visible.sync="deleteUserDialogVisible" center>
        <span class="dialog-text">ユーザーを削除しますか？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel-btn" @click="deleteUserDialogVisible = false"
            >キャンセル</el-button
          >
          <el-button @click="_onClickDeleteUser()" class="blue-text-users"
            >はい</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UsecaseFactory from "@/usecases/usecase.factory.js";
const userUsecase = UsecaseFactory.create("user");

export default {
  components: {},
  data () {
    return {
      UserId: "",
      users: [],
      deleteUserDialogVisible: false,
      clients: [],
      tableHeight: screen.height - 279,
    };
  },
  async created () {
    this.update();
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
    }),
  },
  methods: {
    async update () {
      this.users = await userUsecase.getUsers({
        q: {
          clientGroupId: this.clientGroup.id,
        },
      });
      this.users.forEach(user => {
        if (user.role !== "ADMIN") {
          this.clients.push(user);
        }
      });
    },
    /* edit user */
    _onClickEditUser (id) {
      const { $router } = this;
      this.$store.commit("user/setUserId", id);
      $router.push({ name: "admin/clients/users/edit", params: { id } });
    },
    /* to open delete user dialog */
    getDeleteUserDialog (id) {
      this.deleteUserDialogVisible = true;
      this.UserId = id;
    },
    /* to on click delete user */
    async _onClickDeleteUser () {
      var message = "";
      const loading = this.$loading();
      try {
        // delete it
        await this.deleteUserInfos();

        // it succeed, so I notify it
        message = "ユーザーを削除しました。";
        this.$notify({ message });

        // set initial clients
        this.clients = [];

        // get client list
        this.update();
      } catch (err) {
        alert(err.errors[0].message);
        return;
      } finally {
        loading.close();
      }
    },
    /* to delete user information */
    async deleteUserInfos () {
      this.deleteUserDialogVisible = false;
      if (this.UserId) {
        const res = await userUsecase.deleteUser({ userId: this.UserId });
        return res;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.UserTable {
  width: 100%;
}
::v-deep .el-table th {
  text-align: center;
}
::v-deep .el-table_1_column_1 {
  text-align: left;
}
@media (min-width: 767px) {
 ::v-deep .el-table_1_column_1.UserTable-Cell .cell {
    margin-left: 1.5rem;
  }
}
@media (max-width: 768px) {
  ::v-deep .el-table_1_column_1.UserTable-Cell .cell {
    margin-left: 0.5rem;
  }
}
.userActive {
  color: $blue-base;
  font-size: 1.1rem;
}
.user-space {
  margin-right: 1rem;
}
.user-text {
  margin-right: 2rem;
}
::v-deep .el-table th {
  background-color: $background-gray-base !important;
}
::v-deep .el-badge {
  padding-right: 1.2rem;
}
</style>
